module.exports = __webpack_public_path__ + "img/metro.c1aa8384.jpg";